module.exports = __webpack_public_path__ + "img/Map_selected.5aba81cd.svg";